export default __webpack_public_path__ + "static/media/bariol_regular_italic-webfont.cc98da97.woff2";